import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Analytics from './pages/Analytics';
import Revenue from './pages/Revenue';
import Performance from './pages/Performance';
import Apps from './pages/Apps';
import AppDetails from './pages/AppDetails';
import ReportBuilder from './pages/ReportBuilder';
import Reports from './pages/Reports';
import ReportPreview from './pages/ReportPreview';
import Invoices from './pages/Invoices';
import InvoiceDetails from './pages/InvoiceDetails';
import PaymentHistory from './pages/PaymentHistory';
import PaymentMethod from './pages/PaymentMethod';
import FinancialOverview from './pages/FinancialOverview';
import NotFound from './pages/NotFound';
import { authService } from './services/authService';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <Layout>
              <Login />
            </Layout>
          }
        />
        <Route
          path="/"
          element={
            authService.isAuthenticated() ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Layout>
                <Home />
              </Layout>
            )
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/analytics"
          element={
            <ProtectedRoute>
              <Layout>
                <Analytics />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/revenue"
          element={
            <ProtectedRoute>
              <Layout>
                <Revenue />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/performance"
          element={
            <ProtectedRoute>
              <Layout>
                <Performance />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/apps"
          element={
            <ProtectedRoute>
              <Layout>
                <Apps />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/apps/:appKey"
          element={
            <ProtectedRoute>
              <Layout>
                <AppDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Layout>
                <Reports />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/builder"
          element={
            <ProtectedRoute>
              <Layout>
                <ReportBuilder />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ReportPreview />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/finance/invoices"
          element={
            <ProtectedRoute>
              <Layout>
                <Invoices />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/finance/invoices/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <InvoiceDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/finance/payment-history"
          element={
            <ProtectedRoute>
              <Layout>
                <PaymentHistory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/finance/payment-method"
          element={
            <ProtectedRoute>
              <Layout>
                <PaymentMethod />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/finance/overview"
          element={
            <ProtectedRoute>
              <Layout>
                <FinancialOverview />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={
            <Layout>
              <NotFound />
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
